(function( $ ) {
  class Nav {
    constructor() {
      this.dropdownBtn = $('.menu-arrow-btn');
      this.navBarEl = $('#js-navbar');
      this.menuToggleBtn = $('#js-menu-toggle-btn');
      this.header = document.getElementById("masthead");
      this.sticky = this.header.offsetTop;
      this.init();
    }

    init() {
      if ( this.dropdownBtn ) {
        this.dropdownBtn.on( 'click', this.toggleChildMenu )
      }

      if ( this.menuToggleBtn ) {
        this.menuToggleBtn.on( 'click', () => this.toggleNavbar() )
      }

      window.addEventListener( 'scroll', () => this.handleStickyHeader() )
    }

    toggleChildMenu( event ) {
      event.preventDefault();
      event.stopPropagation();
      const childMenuItem = $(event.target).parent().next();
      childMenuItem.toggleClass( 'open' );
    }

    toggleNavbar() {
      if ( this.navBarEl ) {
        this.navBarEl.toggleClass( 'menu-open' )
        $('body').toggleClass( 'fixed' );
      }
    }

    handleStickyHeader() {
      if (window.pageYOffset > this.sticky) {
        this.header.classList.add("sticky");
      } else {
        this.header.classList.remove("sticky");
      }
    }

  }

  new Nav();
})(jQuery)
